import { NgModule } from '@angular/core';
import { CommonModule  } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { GestionStagiairesComponent } from './gestion-stagiaires.component';
import { GestionStagiairesService } from './gestion-stagiaires.service';
import { gestionStagiairesRouting } from './gestion-stagiaires.routes';
import { ListeStagiairesComponent } from './liste-stagiaires/liste-stagiaires.component';
import { AddNewStagiaireComponent } from './add-new-stagiaire/add-new-stagiaire.component';
import { GestionSujetsService } from '../gestion-sujets/gestion-sujets.service';
import { GestionEntreprisesService } from '../gestion-entreprises/gestion-entreprises.service';

@NgModule({
  imports: [
   gestionStagiairesRouting,
   CommonModule,
   HttpModule,
   ReactiveFormsModule,
   FormsModule
  ],
  declarations: [
    GestionStagiairesComponent,
    ListeStagiairesComponent,
    AddNewStagiaireComponent
  ],
  providers: [
    GestionStagiairesService,
    GestionEntreprisesService,
    GestionSujetsService
  ],
  exports: [
    GestionStagiairesComponent
  ]
})
export class GestionStagiairesModule { }



// WEBPACK FOOTER //
// C:/Users/Yassine/Desktop/gestion-stagiaires/src/app/gestion-stagiaires/gestion-stagiaires.module.ts